import { FirebaseData } from "../General/FirebaseData";

export class CompanyInvoiceReceiverData extends FirebaseData {
  receiver: string = "";
  address: string = "";
  postBox: string = "";
  postalCode: string = "";
  email: string = "";
  reference: string = "";
  orgNumber: string = "";

  setup(data: any) {
    this.receiver = typeof data.receiver === "string" ? data.receiver : "";
    this.address = typeof data.address === "string" ? data.address : "";
    this.postBox = typeof data.postBox === "string" ? data.postBox : "";
    this.postalCode = typeof data.postalCode === "string" ? data.postalCode : "";
    this.email = typeof data.email === "string" ? data.email : "";
    this.reference = typeof data.reference === "string" ? data.reference : "";
    this.orgNumber = typeof data.orgNumber === "string" ? data.orgNumber : "";

    super.setup(data);
  }
}
